const IntroSection = () => (
  <section id="centro" className="border-y border-slate-100 bg-slate-50/80 py-24">
    <div className="container mx-auto max-w-3xl px-6">
      <h2 className="mb-6 text-3xl font-black tracking-tighter text-slate-900 md:text-4xl">Centro Multidisciplinar Richard Atik</h2>
      <p className="mb-5 text-lg leading-relaxed text-slate-600">
        Desde 1993, el centro nace con la idea de ofrecer a toda persona un lugar de inspiración para mejorar
        distintos aspectos de su vida a través de actividades y servicios que tienen como raíz las enseñanzas del
        Gran Maestro Masaaki Hatsumi y del Maestro Pedro Fleitas.
      </p>
      <blockquote className="rounded-2xl border border-emerald-100 bg-white p-6 text-slate-700">
        <p className="text-base italic leading-relaxed">
          "Nuestro propósito es vivir una vida sana, sin hacer daño a la sociedad, mediante el cultivo de las
          relaciones mutuas entre la Naturaleza y la Humanidad a través de los caminos marciales".
        </p>
        <footer className="mt-3 text-sm font-semibold text-emerald-700">Soke Masaaki Hatsumi</footer>
      </blockquote>
    </div>
  </section>
);

export default IntroSection;
